import EventUser, { IEventUser } from '@/models/EventUser'
import * as dayjs from 'dayjs'
import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'

export interface IEvent extends IModelBase {
  title?: string
  description?: string
  date?: string
  event_image?: string
  additional_message?: string
  manual_url?: string
  external_token?: string
  event_users?: Array<IEventUser>
}

export default class Event extends ModelBase {
  title = ''
  description = ''
  date: string
  event_image: string
  additional_message: string
  manual_url: string
  external_token?: string
  event_users: Array<EventUser> = []

  constructor(defaults?: IEvent) {
    super(defaults)
    if (defaults) {
      this.title = defaults.title
      this.description = defaults.description
      this.date = dayjs(defaults.date).format('YYYY-MM-DDTHH:mm')
      this.event_image = defaults.event_image
      this.additional_message = defaults.additional_message
      this.manual_url = defaults.manual_url
      this.external_token = defaults.external_token
      this.event_users = defaults.event_users?.map(u => {
        const eu = new EventUser(u)
        eu.event = this
        return eu
      }) || []
    }
  }

  get dateNumber(): number {
    return dayjs(this.date).toDate().getTime()
  }

  get dateString(): string {
    return dayjs(this.date).format('YYYY/MM/DD HH:mm')
  }

  get finished(): boolean {
    const diff = dayjs().startOf('day').diff(dayjs(this.date).startOf('day'), 'd')
    return diff > 0
  }

  get yet(): boolean {
    return dayjs().isBefore(dayjs(this.date))
  }

  get open(): boolean {
    return dayjs().isAfter(dayjs(this.date).add(-30, 'minute')) && !this.finished
  }

  toParams(): KeyPair {
    return {
      title: this.title,
      description: this.description,
      date: this.date,
      event_image: this.event_image,
      additional_message: this.additional_message,
      manual_url: this.manual_url,
      external_token: this.external_token
    }
  }
}
